import React from 'react';
import { darkBlack, grey300, white } from 'material-ui/styles/colors';
import { fade } from 'material-ui/utils/colorManipulator';
import Spacing from 'material-ui/styles/spacing';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const palette = {
    primary1Color: 'rgb(35,151,190)',
    accent1Color: 'rgb(100,188,70)',
    accent2Color: 'rgb(35,151,190)',
    textColor: 'rgb(128, 134, 135)',
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: fade(darkBlack, 0.3),
};

export const CentricMuiTheme = getMuiTheme({
    spacing: Spacing,
    palette,
    floatingActionButton: {
        color: palette.accent1Color
    },

    toolbar: {
        textColor: white,
    },

    tableRow: {
        hoverColor: grey300
    }
});

const CentricMuiThemeProvider = ({children}) => (
    <MuiThemeProvider muiTheme={CentricMuiTheme}>
        {children}
    </MuiThemeProvider>
);

export default CentricMuiThemeProvider;
